import { Options, Vue } from "vue-class-component";

import MessageEditor from "@/components/MessageEditor/MessageEditor.vue";
import { MessageModel } from "@/model/api/Message";
import {Prop, Provide} from "vue-property-decorator";
import { messageService } from "@services/message.service";
import {Shift} from "@/model/api/Shift";

@Options({
  components: {
    MessageEditor
  }
})
export default class SendMessageDialog extends Vue {
  @Prop()
  userId: number;

  @Prop()
  readonly shift: Shift;

  @Prop()
  readonly startDateTime: Date

  @Prop({default: null})
  hint: string;

  @Prop()
  text: string;

  @Prop()
  subject: string;

  @Prop({ default: false })
  showRecipientOptions: boolean;

  @Prop({ default: false })
  all: boolean;

  message: MessageModel = new MessageModel();

  onShow() {
    this.text && (this.message.text = this.text);
    this.subject && (this.message.subject = this.subject);
    if(this.shift != null && this.shift.id){
      const editor: any = this.$refs.editor;
      if (editor?.applyDefaultRecipient) {
        // single code path with the recipient radios (see MessageEditor):
        // display and request can never diverge, and the caller-supplied
        // text is restored if the operator leaves the brokers option
        editor.applyDefaultRecipient();
      } else {
        // conservative fallback: never default to a whitelist-wide send
        this.message.is_only_drivers_working = true
      }
    }
  }
  onHide() {
    this.reset();
  }

  async send() {
    this.message.user_id  = this.userId;
    if(this.shift){
      this.message.shift_id = this.shift.id;
    }
    this.$waitFor( async () => {
      await messageService.send(this.message);
      this.$successMessage("Message sent");
      this.$emit("sent");

      this.reset();
      
      this.close();
      
    });
  }

  private reset() {
    this.message = new MessageModel();
  }

  private close() {
    this.$emit('update:visible', false);
  }
}
